import initialStateSubscribable from '@/shared/mixins/store/subscribableData/initialState';

import { ProductVisibilitiesState } from './types';

export default function initialState(): ProductVisibilitiesState {
  return {
    ...initialStateSubscribable(),
  };
}
